module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.issues.length) ? _c('full-video', {
    attrs: {
      "showKeywords": true,
      "issue": _vm.issues[0]
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "videos-list"
  }, _vm._l((_vm.issues), function(issue, index) {
    return (index > 0 && index < 7) ? _c('div', {
      key: issue.id,
      staticClass: "video-item"
    }, [_c('condensed-video', {
      attrs: {
        "issue": issue,
        "showKeywords": true
      }
    })], 1) : _vm._e()
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b2166c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/VideosPage.vue
// module id = 1412
// module chunks = 1